// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** @internal */
export const MAX_CALLING_CODE_LENGTH = 3;

/** @internal */
export const MAX_NUMBER_LENGTH = 13;

/** @internal */
export const MASK_SYMBOL = '0';

/** @internal */
export const format0 = '000-000-0000';

/** @internal */
export const format2 = '000 000 00000';

/** @internal */
export const format1 = '00 0000000000';

/** @internal */
export const format5 = '00 000 00000';

/** @internal */
export const format14 = '0 00000000';

/** @internal */
export const format4 = '000 00 00 00';

/** @internal */
export const format3 = '0 00 00 00 00';

/** @internal */
export const format8 = '00 000 00 00';

/** @internal */
export const format7 = '000 0000000000';

/** @internal */
export const format11 = '0000 000000';

/** @internal */
export const format9 = '00 00 00 0000';

/** @internal */
export const format17 = '00000 000000';

/** @internal */
export const format24 = '0 0000 0000';

/** @internal */
export const format18 = '000-0000000';

/** @internal */
export const format32 = '00-0000-0000';

/** @internal */
export const format12 = '0 000 000000';

/** @internal */
export const format13 = '00 00 000 000';

/** @internal */
export const format25 = '00000000';

/** @internal */
export const format19 = '0000-000000';
